import { Box } from "@mui/material";
import CustomText from "./CustomText";

const getDoctorName = (doctor) =>
  [doctor?.nombre, doctor?.apellido_paterno, doctor?.apellido_materno]
    .filter(Boolean)
    .join(" ");

const DoctorCard = ({ doctor, colorIcon, onClick }) => {
  const doctorName = getDoctorName(doctor) || "Médico";
  const specialty = doctor?.especialidad || "Especialista";

  return (
    <Box sx={styles.CardWrapper} onClick={onClick}>
      <Box className="doctor-card-inner" sx={styles.CardInner}>
        <Box sx={styles.CardFront}>
          <Box sx={styles.ImageContainer}>
            <Box
              component="img"
              src={doctor?.imagen}
              alt={doctorName}
              sx={styles.DoctorImage}
            />
          </Box>
          <Box sx={styles.Information}>
            <Box sx={styles.DoctorInfo}>
              <CustomText
                fontFamily="Nunito"
                fontWeight={700}
                fontSize={{ xs: 16, md: 16 }}
                color="#2349D0"
                sx={styles.text}
              >
                Dr. {doctorName}
              </CustomText>
              <CustomText
                fontFamily="Nunito"
                fontSize={{ xs: 11, md: 13 }}
                color="#777"
              >
                {specialty}
              </CustomText>
            </Box>
          </Box>
        </Box>
        <Box sx={styles.CardBack}>
          <CustomText
            fontFamily="Nunito"
            fontWeight={700}
            fontSize={{ xs: 20, md: 18 }}
            color="#2349D0"
          >
            Dr. {doctorName}
          </CustomText>
          <CustomText
            fontFamily="Nunito"
            fontSize={{ xs: 14, md: 14 }}
            color="#666"
            marginBottom={2}
          >
            {specialty}
          </CustomText>
          {doctor?.centro_estudios && (
            <Box sx={styles.BackInfo}>
              <CustomText
                fontFamily="Nunito"
                fontWeight={600}
                fontSize={{ xs: 10, md: 12 }}
                color="#999"
              >
                Centro de estudios
              </CustomText>
              <CustomText
                fontFamily="Nunito"
                fontSize={{ xs: 11, md: 13 }}
                color="#333"
                lineHeight={1.2}
              >
                {doctor.centro_estudios}
              </CustomText>
            </Box>
          )}
          {doctor?.cedula && (
            <Box sx={styles.BackInfo}>
              <CustomText
                fontFamily="Nunito"
                fontWeight={600}
                fontSize={{ xs: 10, md: 12 }}
                color="#999"
              >
                Cédula profesional
              </CustomText>
              <CustomText
                fontFamily="Nunito"
                fontSize={{ xs: 11, md: 13 }}
                color="#333"
                lineHeight={1.2}
              >
                {doctor.cedula}
              </CustomText>
            </Box>
          )}
          <CustomText
            fontFamily="Nunito"
            fontSize={{ xs: 11, md: 12 }}
            color="#888"
            sx={styles.BackHint}
          >
            Ver información
          </CustomText>
        </Box>
      </Box>
    </Box>
  );
};

export default DoctorCard;

const styles = {
  CardWrapper: {
    width: {
      xs: "calc(100vw - 100px)",
      sm: 280,
      md: 205,
      lg: 280,
    },
    minWidth: {
      xs: "calc(100vw - 100px)",
      sm: 280,
      md: 205,
      lg: 205,
    },
    height: {
      xs: 310,
      sm: 320,
      md: 245,
      lg: 320,
    },
    position: "relative",
    perspective: "1000px",
    WebkitPerspective: "1000px",
    cursor: "pointer",
    touchAction: "manipulation",
    "@media (hover: hover) and (pointer: fine)": {
      "&:hover .doctor-card-inner": {
        transform: "rotateY(180deg)",
      },
    },
  },
  text: { px: 1 },
  CardInner: {
    position: "relative",
    width: "100%",
    height: "100%",
    transform: "rotateY(0deg)",
    transformStyle: "preserve-3d",
    WebkitTransformStyle: "preserve-3d",
    transition: "transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
    willChange: "transform",
  },
  CardFront: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    overflow: "hidden",
    boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.20)",
    display: "flex",
    flexDirection: "column",
    backfaceVisibility: "hidden",
    WebkitBackfaceVisibility: "hidden",
  },
  CardBack: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "#F1F1F1",
    borderRadius: "20px",
    padding: {
      xs: 2,
      md: 2,
    },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.20)",
    transform: "rotateY(180deg)",
    backfaceVisibility: "hidden",
    WebkitBackfaceVisibility: "hidden",
    boxSizing: "border-box",
  },
  ImageContainer: {
    width: "100%",
    height: {
      xs: 245,
      sm: 250,
      md: 205,
      lg: 240,
    },
    borderRadius: "20px",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  DoctorImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center",
    display: "block",
  },
  Information: {
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  DoctorInfo: {
    minWidth: 0,
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  BackInfo: {
    width: "100%",
    marginBottom: 1.5,
  },
  BackHint: {
    marginTop: 1.5,
    opacity: 0.8,
  },
};
